module.exports = __webpack_public_path__ + "img/home_image.51df4e0c.svg";